import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestError } from '@/app/common/types_and_interfaces.ts'
import { PURSE_KEYS } from '@/queries/program_purses/keys.ts'
import {
  transferPurseFunds,
  TransferPurseFundsParams,
} from '@/queries/program_purses/requests.ts'

export const useTransferPurseFunds = (
  options?: UseMutationOptions<unknown, RequestError, TransferPurseFundsParams>
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: transferPurseFunds,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: PURSE_KEYS.PURSE_DETAILS(
          String(variables.purseId),
          variables.programId
        ),
      })
      queryClient.invalidateQueries({
        queryKey: PURSE_KEYS.PURSE_DETAILS(
          String(variables.targetProgramPurseId),
          variables.programId
        ),
      })
      queryClient.invalidateQueries({
        queryKey: PURSE_KEYS.PURSES(variables.programId),
      })
      queryClient.invalidateQueries({
        queryKey: ['TRANSACTION_LOGS', variables.programId, variables.purseId],
      })
      queryClient.invalidateQueries({
        queryKey: [
          'TRANSACTION_LOGS',
          variables.programId,
          variables.targetProgramPurseId,
        ],
      })

      options?.onSuccess?.(data, variables, context)
    },
    onError: options?.onError,
    onSettled: options?.onSettled,
  })
}
